import { render, staticRenderFns } from "./discourseRecord.vue?vue&type=template&id=c8c2e5f8&scoped=true"
import script from "./discourseRecord.vue?vue&type=script&lang=js"
export * from "./discourseRecord.vue?vue&type=script&lang=js"
import style0 from "./discourseRecord.vue?vue&type=style&index=0&id=c8c2e5f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c2e5f8",
  null
  
)

export default component.exports